import { render, staticRenderFns } from "./sipariskalemler.vue?vue&type=template&id=98749820"
import script from "./sipariskalemler.vue?vue&type=script&lang=js"
export * from "./sipariskalemler.vue?vue&type=script&lang=js"
import style0 from "./sipariskalemler.vue?vue&type=style&index=0&id=98749820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports